import env from "./envConfig";

enum LogLevels { ERROR, WARN, INFO, DEBUG };

class DebugLog {
    private logLevel: LogLevels;

    constructor (logLevel: LogLevels = LogLevels.WARN) {
        let envLevel = parseInt(env.REACT_APP_DEBUG_VISIBILITY ?? "")
        this.logLevel = envLevel ? envLevel : logLevel;
        console.log("Logger established with log level", this.logLevel)
    }

    emitLog (level: LogLevels, ...args: any[]) {
        if (level <= this.logLevel) {
            switch (level) {
                case LogLevels.ERROR:
                    console.error(...args); return;
                case LogLevels.WARN:
                    console.warn(...args); return;
                case LogLevels.INFO:
                    console.info(...args); return;
                default:
                    console.log(...args); return;
            }
        }
    }

    error (...args: any[]) { this.emitLog(LogLevels.ERROR, ...args); }
    warn (...args: any[]) { this.emitLog(LogLevels.WARN, ...args); }
    info (...args: any[]) { this.emitLog(LogLevels.INFO, ...args); }
    log (...args: any[]) { this.emitLog(LogLevels.DEBUG, ...args); }

}
/**
Use this like you'd use `console.log` or similar - `debugLog.log()` is equivalent to `console.log()`, and so on.
Not seeing your logs? Edit the `REACT_APP_DEBUG_VISIBILITY` variable in the env file. 
Log level can be anywhere from `0` to `3`, with: 
- `0` displaying only errors
- `1` displaying only errors and warnings. ***This is the default value.***
- `2` displaying only errors, warnings, and info. 
- `3` displaying all console messages.
*/
const debugLog = new DebugLog();
export { debugLog };